import React, { useEffect } from "react";
import Footer from "./Footer";
import CustomHeading from "./custom/CustomHeading";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 20);
  }, []);
  return (
    <div className="px-[6%] text-left sm:text-justify lg:px-[8%] py-[3%]">
      <CustomHeading smTextSize="32px" textSize="60px" textColor="#d31c4f" leading="72px" marginTop={"32px"} text={"Privacy Policy"}/>
      <h2 className="mt-3 font-semibold">Effective Data: April 2025</h2>
      <p className="mt-2 text-lg">
        We at <b>Mother’s Pride Preschool</b> firmly believe in protecting your
        privacy. This Privacy Policy explains how we gather, make use of, and
        protect your personal data when you visit our website
        https://www.motherspridepreschool.com/ or utilize any of our services.{" "}
      </p>
      <div className="flex flex-col gap-4 mt-8">
        <div className="flex flex-col gap-3">
          <h1 className="font-semibold text-lg">1. Information We Collect</h1>
          <div>
            <p className="font-medium">
              The following types of information might be collected by us:
            </p>
            <p className="mt-[2px]">
              <b>- Personal Information :</b>Personal Information encompasses
              name, email address, phone number, child’s name, and other details
              that were provided by you while filling out the forms available on
              our website.{" "}
            </p>
            <p className="mt-[2px]">
              <b>- Usage Data :</b>This is information that relates to the
              manner in which you use our website, including IP address, type of
              computer, pages accessed, and the time spent on each page within
              the website.
            </p>
            <p className="mt-[2px]">
              <b>- Cookies & Tracking Technologies :</b>We analyze the traffic
              of the website and enhance the user's experience by collecting
              cookies and other similar technologies.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="font-semibold text-lg">
            2. How We Use Your Information
          </h1>
          <div>
            <p className="font-medium">
              The information we collect is used to:
            </p>
            <p className="mt-[2px]">- Provide and improve the service.</p>
            <p className="mt-[2px]">
              - Respond to queries and communicate with clients.
            </p>
            <p className="mt-[2px]">
              - Communicate updates, newsletters, or promotional material (with
              the option to opt out anytime).{" "}
            </p>
            <p className="mt-[2px]">
              - Maintain security of the website and prevent fraud.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="font-semibold text-lg">3. Sharing of Information</h1>
          <div>
            <p className="font-medium">
              Personal information is not sold or rented out to anyone. This
              information will however may be disclosed to:
            </p>
            <p className="mt-[2px]">
              <b>- Trusted Service Providers:</b>These include other third-party
              advertisers focusing on website hosting, analytics and marketing
              services.
            </p>
            <p className="mt-[2px]">
              <b>- Compliance With Legal Duty:</b>To comply with legal
              obligations or to protect our rights, we may share information
              with authorities when it is required by law.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="font-semibold text-lg">4. Data Safety</h1>
          <p className="font-medium">
            Preventive measures have been put in place for the protection your
            personal information and identity against ineffective intrusion,
            manipulations, or unveiling. Nonetheless, no form of online data
            transmission is completely safe.
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="font-semibold text-lg">5. Your Rights and Options </h1>
          <div>
            <p className="font-medium">You have the right to:</p>
            <p className="mt-[2px]">
              - Gain access to your data, modify it, or ask for its removal.
            </p>
            <p className="mt-[2px]">
              - Stop receiving emails regarding promotions.
            </p>
            <p className="mt-[2px]">
              - Remove cookies via the processor’s configurations.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="font-semibold text-lg">6. Exeternal Websites</h1>
          <p className="font-medium">
            Our website includes hyperlinks to websites which are not affiliated
            with or controlled by us. We are not responsible for their privacy
            policies and practices so it is advisable to examine those.
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="font-semibold text-lg">7. Kids Privacy</h1>
          <p className="font-medium">
            Our policy regarding kids is that we do not intentionally obtain
            kids’ personal information unless their guardian or parent has
            allowed it.{" "}
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="font-semibold text-lg">
            8. Modifications of This Policy
          </h1>
          <p className="font-medium">
            This Privacy Policy is subject to revisitation and editorial changes
            on a regular basis. Every modification will be shown on this section
            together with a new date of application.
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="font-semibold text-lg">
            9. Inquiries Contact Us Via:
          </h1>
          <p className="font-medium">
            If you need further assistance on this privacy policy, direct your
            inquiries to the aforementioned address.
          </p>
        </div>
      </div>
      <div className="flex text-left flex-col gap-1 mt-6">
        <p>📍 Mother's Pride Preschool</p>
        <p>📧 Email:websites@motherspridepreschool.com</p>
        <p>📞 Phone:917290011862</p>
      </div>
      <Footer marginX={"0%"} />
    </div>
  );
};

export default Privacy;
